import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModuleTitle from "../../../components/common/title";
import ModuleCard from "../../../components/common/card";
import { option_category_obj } from "../../../service/option";

import ImgDisease from "../../../images/common/disease.png";
import ImgDiet from "../../../images/common/diet.png";
import ImgExercise from "../../../images/common/exercise.png";
import ImgExpress from "../../../images/common/express.png";
import ImgEnvironment from "../../../images/common/environment.png";
import ImgMedicine from "../../../images/common/medicine.png";
import ImgMeasure from "../../../images/common/measure.png";

export default function MemberKnowledge() {
  const crumbItem = [
    { key: 1, label: "首頁", href: "/member" },
    { key: 2, label: "知識" },
  ];
  const cardData = [
    {
      title: option_category_obj.knowledge.disease.label,
      img: ImgDisease,
      url: `/member/knowledge/${option_category_obj.knowledge.disease.value}`,
    },
    {
      title: option_category_obj.knowledge.diet.label,
      img: ImgDiet,
      url: `/member/knowledge/${option_category_obj.knowledge.diet.value}`,
    },
    {
      title: option_category_obj.knowledge.exercise.label,
      img: ImgExercise,
      url: `/member/knowledge/${option_category_obj.knowledge.exercise.value}`,
    },
    {
      title: option_category_obj.knowledge.express.label,
      img: ImgExpress,
      url: `/member/knowledge/${option_category_obj.knowledge.express.value}`,
    },
    {
      title: option_category_obj.knowledge.environment.label,
      img: ImgEnvironment,
      url: `/member/knowledge/${option_category_obj.knowledge.environment.value}`,
    },
    {
      title: option_category_obj.knowledge.medicine.label,
      img: ImgMedicine,
      url: `/member/knowledge/${option_category_obj.knowledge.medicine.value}`,
    },
    {
      title: option_category_obj.knowledge.measure.label,
      img: ImgMeasure,
      url: `/member/knowledge/${option_category_obj.knowledge.measure.value}`,
    },
  ];

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle data={{ title: "知識" }} />

      <ModuleCard data={cardData} />
    </>
  );
}
